import { render, staticRenderFns } from "./RelatedSite.vue?vue&type=template&id=9858166e&"
import script from "./RelatedSite.vue?vue&type=script&lang=ts&"
export * from "./RelatedSite.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedSite.vue?vue&type=style&index=0&id=9858166e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports